import { ScheduleTimeSpan } from '../models/serializable/schedule-time-span.js';

export abstract class ISchedule {
  abstract get times(): ScheduleTimeSpan[];
  abstract get closed(): boolean;
}
